export default __webpack_public_path__ + "static/media/thumbnail.d8ed1c74.jpg";